<template>
  <LegalDocumentPage
    document-type="privacy_policy"
    fallback-title-key="footer.privacyPolicy"
  />
</template>

<script setup>
import LegalDocumentPage from '../components/legal/LegalDocumentPage.vue';
</script>
